export enum ShopItemType {
  COMMISSIONS = 'commissions',
  PRINTS = 'prints',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
  DAS = 'digital_assets',
}
